import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {getTestResult} from "../../services/TestRepository";
import {getInterpolatedColor, score_palette} from "../../components/color/Palettes";
import Header from "../../components/navigation/Header";
import {ScrollActivatedBargraph} from "../../components/graph/ScrollActivatedBargraph";
import {TextContent} from "../course/TextContent";
import {AiOutlineCheckCircle, AiOutlineCloseCircle} from "react-icons/ai";
import {ProgressBar} from "../../components/ProgressBar";
import {FaAngleDoubleLeft} from "react-icons/fa";
import {useError} from "../../hooks/useError";

export function TestResult({id, hideHead}) {

    const params = useParams();
    const [testResult, setTestResult] = useState(null);
    const [product, setProduct] = useState(null);
    const {setErrorMessage} = useError();

    useEffect(() => {
        console.log("THE ID: ", params.id)
        getTestResult(id != null ? id : params.id, setErrorMessage).then(result => {
            console.log(result);
            setTestResult(result);
        });
    }, []);


    function renderOption(option, answers) {
        if (option.correct) {
            if (answers.includes(option.id)) {
                return (
                    <AiOutlineCheckCircle size={24} className={"text-success"}/>
                );
            } else {
                return (
                    <p className={"text-muted m-0 p-0 text-center"}>1</p>
                );
            }
        } else {
            if(answers.includes(option.id)) {
                return (
                    <AiOutlineCloseCircle size={24} className={" text-danger"}/>
                );
            } else {
                return (
                    <p className={"text-muted m-0 p-0 text-center"}>0</p>
                );
            }
        }
    }

    function renderQuestion(item, idx) {


        return (
            <div className={"row w-100"}>
                <div className={"col "}>
                    <h5 className={"fw-bold"}>{idx + 1}. {item.question.text}</h5>
                    {
                        item.question.options.map((option) => renderOption(option, item.answers))
                    }
                </div>
                <div className={"col-2 d-flex align-items-center justify-content-center"}>
                    <h4>
                        {item.points}/{item.maxPoints}
                    </h4>
                </div>



            </div>
        )


    }

    if (testResult != null) {
        const score =  Math.floor((testResult.total / testResult.maxPoints) * 100);
        return (
            <>
                <Header/>

                <div className={" bg-white"}>
                    <div className={"container bg-white"}>
                        <Link to={"#"} className={"text-decoration-none ps-0 mt-3 btn  text-dark d-flex align-items-center"}>
                            <FaAngleDoubleLeft size={24} className={"me-2"}/>
                            <label className={"clickable"}>Tilbake til fag</label>
                        </Link>
                        <div className={" row align-items-center mb-5"}>
                            <div className={"col"}>
                                <h1>{testResult.quiz.name}</h1>
                                <h4 className={""}>Du
                                    fikk <strong>{testResult.total} poeng</strong> av {testResult.maxPoints} totalt</h4>
                                <ProgressBar progress={score} height={35}
                                             show={true} color={getInterpolatedColor(score_palette, score, 0, 100)}/>
                            </div>
                            <div className={"col"}>
                            </div>

                        </div>




                        <div className={"row "}>

                            <div className={"col"}>
                                <table className={"table border"}>
                                    <thead>
                                    <tr className={""}>
                                        <th className={"ps-3 "}>
                                            <h4 className={"fw-bold"}>Total</h4>
                                        </th>
                                        <th className={"text-center"}>
                                            <h4 className={"fw-bold"}>
                                                {testResult.total}
                                            </h4>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        testResult.data.map((item, idx) => (
                                            <>

                                                <tr className={"bg-light "}>
                                                    <td className={"fw-bold ps-3"}>
                                                        <TextContent value={item.question.text} level={3} noMargin={true}/>
                                                    </td>
                                                    <td className={"text-center"}>
                                                        <h5>{item.points}/{item.maxPoints}</h5>
                                                    </td>
                                                </tr>
                                                {
                                                    item.question.options.map(option => (
                                                        <tr>
                                                            <td className={"ps-4"}>{option.text}</td>
                                                            <td className={" text-center"}>{renderOption(option, item.answers)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </>
                                        ))
                                    }

                                    </tbody>
                                </table>
                                <h4 className={"mt-4 fw-bold"}>Score per tema</h4>
                                <ScrollActivatedBargraph data={testResult.tagData} keys={testResult.tagData.keys}/>

                            </div>


                        </div>

                    </div>
                </div>
            </>


        );

    }


}